import styled from 'styled-components';

import CommonButton from '~components/Button';
import Text from '~components/Text';

export const Wrapper = styled.div`
  padding: 24px 0;
  text-align: center;
`;

export const Title = styled(Text)`
  display: block;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.gray800};
`;

export const Button = styled(CommonButton)`
  background-color: ${({ theme }) => theme.colors.blue500};

  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
`;
